<template>
  <modal-card
    title="Interviews"
    fixed
    padding
    :full="!canSkipContact"
    :loading="loading"
    @close="$emit('close')"
  >
    <v-alert
      v-if="interviewError"
      transition="fade-transition"
      class="mb-6 pa-2"
      :type="interviewError.type"
      v-html="interviewError.message"
    />

    <template #actions v-if="canSkipContact">
      <v-btn color="appMain" text @click="skipContact" :loading="saving">
        Next Contact
      </v-btn>
    </template>
  </modal-card>
</template>

<script>
import { mapActions } from 'vuex';

const CONTACT_ERRORS = {
  recruit_id: {
    type: 'error',
    message: 'Unable to get recruit ID from contact.',
  },
  training_set: {
    type: 'info',
    message:
      'This contact is already set for training. <br> No interview required.',
  },
};

export default {
  name: 'ContactInterviewError',
  props: {
    contactId: String,
    contact: {
      type: Object,
      default: () => ({}),
    },
    serverError: {
      type: Object,
      default: null,
    },
    loading: Boolean,
  },
  data() {
    return {
      saving: false,
    };
  },

  computed: {
    canSkipContact() {
      return !!this.serverError || !this.hasRecruitId;
    },
    hasRecruitId() {
      return Boolean(this.contact?.recruit_id);
    },
    interviewError() {
      if (!this.contact) return;

      if (!this.hasRecruitId) return CONTACT_ERRORS.recruit_id;

      if (this.contact.training_set) return CONTACT_ERRORS.training_set;

      return this.serverError;
    },
  },
  methods: {
    ...mapActions(['updateContactField']),

    async skipContact() {
      try {
        this.saving = true;

        await this.updateContactField({
          contactId: this.contactId,
          field: 'last_contacted',
          value: new Date(),
        });

        this.$emit('close');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
